var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55.8809,
    height: 55.8809,
    rx: 14,
    fill: "#FCDDD8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 35.2222C27 35.7745 27.4477 36.2222 28 36.2222C28.5523 36.2222 29 35.7745 29 35.2222L27 35.2222ZM29 25.1111C29 24.5588 28.5523 24.1111 28 24.1111C27.4477 24.1111 27 24.5588 27 25.1111L29 25.1111ZM27 20.7922C27 21.3445 27.4477 21.7922 28 21.7922C28.5523 21.7922 29 21.3445 29 20.7922H27ZM29 20.7777C29 20.2254 28.5523 19.7777 28 19.7777C27.4477 19.7777 27 20.2254 27 20.7777H29ZM29 35.2222L29 25.1111L27 25.1111L27 35.2222L29 35.2222ZM29 20.7922V20.7777H27V20.7922H29ZM40 28C40 34.6274 34.6274 40 28 40V42C35.732 42 42 35.732 42 28H40ZM28 40C21.3726 40 16 34.6274 16 28H14C14 35.732 20.268 42 28 42V40ZM16 28C16 21.3726 21.3726 16 28 16V14C20.268 14 14 20.268 14 28H16ZM28 16C34.6274 16 40 21.3726 40 28H42C42 20.268 35.732 14 28 14V16Z",
    fill: "#DA1F3C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.e6514452b9bc0fa8f777e2bc8125424d.svg";
export { ForwardRef as ReactComponent };